export default __webpack_public_path__ + "static/media/icon_pig.65e934ef.svg";